import {
  ANALYTICS_IDENTITY,
  ATPLIVECHAT_RESET,
  ATPLIVECHAT_SET_USER,
} from '../constants/appEvents';
import AnalyticsHelper from './AnalyticsHelper';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { emitter } from 'shared/helpers/mitt';

export const initializeAnalyticsEvents = () => {
  AnalyticsHelper.init();
  emitter.on(ANALYTICS_IDENTITY, ({ user }) => {
    AnalyticsHelper.identify(user);
  });
};

export const initializeAudioAlerts = user => {
  const { ui_settings: uiSettings } = user || {};
  const {
    always_play_audio_alert: alwaysPlayAudioAlert,
    enable_audio_alerts: audioAlertType,
    alert_if_unread_assigned_conversation_exist: alertIfUnreadConversationExist,
    notification_tone: audioAlertTone,
    // UI Settings can be undefined initially as we don't send the
    // entire payload for the user during the signup process.
  } = uiSettings || {};

  const shouldUseDefaultAudioAlerts =
    !audioAlertType || audioAlertType === 'none';

  DashboardAudioNotificationHelper.set({
    currentUser: user,
    audioAlertType: shouldUseDefaultAudioAlerts
      ? 'assigned+unassigned'
      : audioAlertType,
    audioAlertTone: audioAlertTone || 'ding',
    alwaysPlayAudioAlert: alwaysPlayAudioAlert ?? true,
    alertIfUnreadConversationExist: alertIfUnreadConversationExist ?? true,
  });
};

export const initializeATPLiveChatEvents = () => {
  emitter.on(ATPLIVECHAT_RESET, () => {
    if (window.$atplivechat) {
      window.$atplivechat.reset();
    }
  });
  emitter.on(ATPLIVECHAT_SET_USER, ({ user }) => {
    if (window.$atplivechat) {
      window.$atplivechat.setUser(user.email, {
        avatar_url: user.avatar_url,
        email: user.email,
        identifier_hash: user.hmac_identifier,
        name: user.name,
      });
      window.$atplivechat.setCustomAttributes({
        signedUpAt: user.created_at,
        cloudCustomer: 'true',
        account_id: user.account_id,
      });
    }

    initializeAudioAlerts(user);
  });
};
